/**
 * 유효성 검증 실패(alert) 시 해당 입력 요소로 부드럽게 스크롤한다.
 * 결제 화면에서 미입력 항목 안내 후 사용자가 위치를 찾기 쉽도록 사용.
 */
export const scrollToInvalidField = (el?: HTMLElement | null): void => {
  el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
